module.exports = "https://web-assets.ifttt.com/packs/media/settings/deactivate-icon-d428c296.svg";